import { SyntheticTokenV1Factory } from '@arcxgame/contracts/dist/src/typings/SyntheticTokenV1Factory'
import { Erc20Details, useAsync } from '@arcxmoney/arcx-react'
import { BigNumber } from 'ethers'
import humanFormat from 'human-format'
import React, { useContext } from 'react'
import { tokens } from 'src/assets/images'
import { ArcContext } from 'src/contexts/ArcContext'
import { Synth } from 'src/services/GraphService'
import { formatBigNumber } from 'src/utils/format/formatBigNumber'
import { DashboardItem } from '../DashboardItem'

interface IProps {
  synth: Synth
  lockedAmount: BigNumber
  lockedValue: number
  collateralDetails: Erc20Details
}

export function AssetLocked({ collateralDetails, lockedAmount, lockedValue, synth }: IProps) {
  const { arc } = useContext(ArcContext)

  const [maximumCap] = useAsync(async () => {
    if (!arc?.signer) {
      return
    }
    const token = SyntheticTokenV1Factory.connect(synth.syntheticAddress, arc?.signer)
    return token.getMinterLimit(synth.id)
  }, [arc?.signer])

  const [currentIssued] = useAsync(async () => {
    if (!arc?.signer) {
      return
    }
    const token = SyntheticTokenV1Factory.connect(synth.syntheticAddress, arc?.signer)
    return token.getMinterIssued(synth.id)
  }, [arc?.signer])

  return (
    <DashboardItem
      title={synth.collateral}
      titleIcon={tokens[synth.collateral.toLowerCase()]}
      rows={[
        {
          property: 'Locked',
          value: `${humanFormat(
            Number(formatBigNumber(lockedAmount, collateralDetails?.decimals)),
          )}`,
        },
        {
          property: 'Value',
          value: `$${humanFormat(lockedValue)}`,
        },
        {
          property: 'STABLEx Limit',
          value: `
          ${currentIssued ? humanFormat(Number(formatBigNumber(currentIssued.value))) : '?'} /
          ${maximumCap ? humanFormat(Number(formatBigNumber(maximumCap))) : '?'}
          `,
        },
      ]}
    />
  )
}
